import React from 'react';
import LazyLoad from 'react-lazyload';
import { getPictureApiUrl } from '../../../../apis/devices';

export default class DeviceImage extends React.Component {

    cleanText(str) {
        if (str === undefined || str === null || str.trim() === '') {
            return '';
        }
        return str.replace("\n", "");
    }

    render() {

        if (!this.props.device) {
            return null;
        }

        const picRef = this.props.device.picRef
            ? getPictureApiUrl(this.props.device.picRef)
            : null;

        return (
            <div>
                <div className="selection-labels-device-image">
                    <p>
                        <b>{this.props.device.deviceTypeName}</b>
                    </p>
                    <p>
                        EAN/NAED: {this.props.device.gtin || this.props.device.naed}
                    </p>
                    <p>
                        Basic Code: {this.props.device.basicCode}
                    </p>
                </div>
                <div className="selection-labels-device-image">
                    <p>
                        {this.cleanText(this.props.device.deviceDescription)}
                    </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <LazyLoad className="app thumb-placeholder center"
                        once={true}
                        overflow={true}
                        offset={[0, 300]}
                        placeholder={<i className="ui centered icon camera" />}>
                        <img className="app thumb-image" style={{ maxHeight: '38vh', width: '80%' }} src={`${picRef}`} alt="" />
                    </LazyLoad>
                </div>
            </div>
        );
    };
};
